import { store } from '../../store/configureStore'
import { setNodes } from '../treeEngine'
import { moveCursorTo } from '../../store/cursor'
import {
    setSyncd,
    setSyncStatus,
    setSyncHash,
    selectSyncStatus,
    selectSyncHash,
    setUpdateExportStartTime
} from '../../store/sync'
import { getState as getRemoteState, postState, postPartialState, getStateHash } from './api'
import { delay, timeout } from '../../utils/asyncTools'
import { getAndResetUnsyncedNodeIds } from '../treeEngineSync'

const { dispatch, getState } = store

export const doRemoteImport = async (hist) => {
    return getRemoteState().then((response) => {
        if (hist) {
            hist.push('/')
        } else {
            history.pushState('', document.title, '/')
        }
        const { tree, cursorNodeId, hash } = response
        setNodes(tree)
        dispatch(moveCursorTo(cursorNodeId))
        dispatch(setSyncd())
        dispatch(setSyncHash(hash))
        return response
    })
}

export const doRemoteExport = async () => {
    const { nodes, cursor } = getState()
    const { cursorNodeId } = cursor

    const data = {
        tree: nodes,
        cursorNodeId
    }

    dispatch(setUpdateExportStartTime(new Date().getTime()))
    const response = await postState(data)
    dispatch(setUpdateExportStartTime(undefined))
    dispatch(setSyncd())
    dispatch(setSyncHash(response.hash))
    return response
}

export const doDiffRemoteExport = async () => {
    const diff = getAndResetUnsyncedNodeIds()

    const data = {}
    const { nodes } = getState()
    for (let i = 0; i < diff.length; i++) {
        const k = diff[i]
        data[k] = nodes[k]
    }

    dispatch(setUpdateExportStartTime(new Date().getTime()))
    const response = await postPartialState(data)
    dispatch(setUpdateExportStartTime(undefined))
    dispatch(setSyncd())
    dispatch(setSyncHash(response.hash))
    return response
}

export const checkSync = async (hist) => {
    const syncHash = selectSyncHash(getState())
    const { saved } = selectSyncStatus(getState())

    const response = await getStateHash()
    const newChangesOnServer = response.hash !== syncHash
    dispatch(setSyncStatus({ newChangesOnServer }))

    if (newChangesOnServer) {
        // safe to download
        if (saved) {
            await doRemoteImport(hist)
        } else {
            return 'conflict'
        }
    } else {
        // safe to upload
        if (!saved) {
            await doDiffRemoteExport()
        } else {
            // all sync'd
            return
        }
    }
}

export const initRemoteImportExport = async () => {
    // eslint-disable-next-line no-constant-condition
    while (true) {
        try {
            await timeout(checkSync(), 30 * 1000)
        } catch {
            // do nothing
        }
        await delay(1000)
    }
}
